import * as React from 'react';

function AccessCodeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g clipPath="url(#clip0)">
        <path d="M9 9V8C9 6.34315 10.3431 5 12 5V5C13.6569 5 15 6.34315 15 8V8.63636V9" stroke="currentColor" />
        <path d="M12 15.5V13.5" stroke="currentColor" strokeLinecap="round" />
        <circle cx="12" cy="13" r="0.5" transform="rotate(-180 12 13)" stroke="currentColor" />
        <rect x="7.5" y="9.5" width="9" height="8" stroke="currentColor" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path d="M0 0H24V24H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default React.memo(AccessCodeIcon);
